import apiSportEventsComments from '@/api/sports-events-comments'

const state = {
  isSubmitting: false,
  error: null,
}

export const mutationTypes = {
  readCommentsStart: '[read comments] Get read comments comments start',
  readCommentsSuccess: '[read comments] Get read comments comments success',
  readCommentsFailure: '[read comments] Get read comments comments failure',
}

export const actionTypes = {
  readComments: '[read comments] Get read comments comments',
}

const mutations = {
  [mutationTypes.readCommentsStart](state) {
    state.isLoadisSubmittinging = true
    state.error = null
  },

  [mutationTypes.readCommentsSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.readCommentsFailure](state, payload) {
    state.isSubmitting = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.readComments](context, {commentIds}) {
    context.commit(mutationTypes.readCommentsStart)
    return new Promise((resolve) => {
      apiSportEventsComments
        .readComments(commentIds)
        .then((response) => {
          context.commit(mutationTypes.readCommentsSuccess, response.data)
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.readCommentsFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
